export default __webpack_public_path__ + "static/media/REUNION_pitch_deck.582a71a0.pdf";